export function debounce<T extends (...args: unknown[]) => void>(
    func: T,
    timeout = 250
): (...args: Parameters<T>) => void {
    let timer: ReturnType<typeof setTimeout>
    return (...args: Parameters<T>) => {
        clearTimeout(timer)
        timer = setTimeout(() => {
            func.apply(this, args)
        }, timeout)
    }
}

export function roundNumber(num: number, scale: number): number {
    if(!(`${  num}`).includes("e")) {
        return +(`${Math.round(`${num  }e+${  scale}`)   }e-${  scale}`);
    } else {
        const arr = (`${  num}`).split("e");
        let sig = ""
        if(+arr[1] + scale > 0) {
            sig = "+";
        }
        return +(`${Math.round(`${+arr[0]  }e${  sig  }${+arr[1] + scale}`)  }e-${  scale}`);
    }
}

export function formatNumberToEuro(amount: number): string {
    return new Intl.NumberFormat("nl-NL", { style: "currency", currency: "EUR" }).format(amount).replace(',00', ',-')
}